import React, { useMemo } from 'react';

import { Industry } from '@/enums';
import { getIndustryProgressGradient } from '@/utils/industryColors';

import * as Style from './ProgressBar.style';

interface Props {
  currentStep: number;
  totalSteps: number;
  industry?: Industry;
  style?: React.CSSProperties;
}

const ProgressBar = ({
  currentStep,
  totalSteps,
  industry = Industry.Agriculture,
  style,
}: Props) => {
  // 計算滑塊高度 - 採用 ProgressBar 的自適應邏輯
  const { barHeight, barTop } = useMemo(() => {
    const k = 100;
    const rawHeight = k / totalSteps;

    // 自適應限制（比例性）
    const minHeight = Math.max(20, 100 / (totalSteps * 2));
    const maxHeight = Math.min(80, 100 / (totalSteps * 0.125));

    // 限定範圍內的滑塊高度
    const barHeight = Math.min(maxHeight, Math.max(minHeight, rawHeight));

    // 可滑動範圍
    const movableArea = 100 - barHeight;

    // 計算目前進度條 top 偏移
    const barTop =
      totalSteps <= 1 ? 0 : (currentStep / (totalSteps - 1)) * movableArea;

    return { barHeight, barTop };
  }, [currentStep, totalSteps]);

  return (
    <Style.ProgressContainer style={style}>
      <Style.ProgressTrack>
        <Style.ProgressThumb
          top={barTop}
          height={barHeight}
          gradient={getIndustryProgressGradient(industry)}
        />
      </Style.ProgressTrack>
    </Style.ProgressContainer>
  );
};

export default ProgressBar;
